









import { defineComponent } from "@vue/composition-api"
import Content from "@/app/components/common/Content.vue"
import Subtitle from "@/app/components/common/Subtitle.vue"

export default defineComponent({
  components: {
    Subtitle,
    Content,
  },
  props: {
    image: {
      type: String,
      default: "barrier.svg",
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    function clicked() {
      emit("click")
    }

    return { clicked }
  },
})
